export const UPDATE_USER = 'auth/UPDATE_USER';
export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const RESPOND_TO_CLI_ERROR = 'auth/RESPOND_TO_CLI_ERROR';
export const SET_CLI_LOGIN_TOKEN = 'auth/SET_CLI_LOGIN_TOKEN';
export const SET_ACCESS_TOKEN = 'auth/SET_ACCESS_TOKEN';
export const SET_EMAIL_REQUIRES_EMAIL_VALIDATION = 'auth/SET_EMAIL_REQUIRES_EMAIL_VALIDATION';
export const EMAIL_VALIDATED = 'auth/EMAIL_VALIDATED';
